import React from 'react';
import { Container, Row } from 'react-bootstrap';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { createImageViewerButton, createImageViewer } from '../../helpers/imageViewerHelpers';
import { createStyledImageListItemBar } from '../../helpers';
import childhoodOne from '../../Assets/DrawingMixedMedia/childhood story 1.jpg';
import childhoodTwo from '../../Assets/DrawingMixedMedia/childhood story 2.jpg';
import childhoodThree from '../../Assets/DrawingMixedMedia/childhood story 3.jpg';
import four from '../../Assets/DrawingMixedMedia/DSC_0179 copy.jpg';
import five from '../../Assets/DrawingMixedMedia/DSC_0195 copy.jpg';
import six from '../../Assets/DrawingMixedMedia/foolmoon 1.jpg';
import seven from '../../Assets/DrawingMixedMedia/foolmoon 2.jpg';
import eight from '../../Assets/DrawingMixedMedia/foolmoon 3.jpg';
import nine from '../../Assets/DrawingMixedMedia/foolmoon 4.jpg';
import pencilAndSpray from '../../Assets/DrawingMixedMedia/pencil and spray .jpg';
import plexi1 from '../../Assets/DrawingMixedMedia/plexi 1.jpg';
import plexi2 from '../../Assets/DrawingMixedMedia/plexi 2.jpg';
import plexi3 from '../../Assets/DrawingMixedMedia/plexi 3.jpg';
import plexi4 from '../../Assets/DrawingMixedMedia/plexi 4.jpg';
import plexi5 from '../../Assets/DrawingMixedMedia/plexi 5.jpg';
import plexi6 from '../../Assets/DrawingMixedMedia/plexi 6.jpg';
import plexi7 from '../../Assets/DrawingMixedMedia/plexi 7.jpg';
import plexi8 from '../../Assets/DrawingMixedMedia/plexi 8.jpg';
import darkMatter from '../../Assets/DrawingMixedMedia/untitled .jpg';

const childhoodStory = [
  {
    img: childhoodOne,
    title: 'spray paint on paper 39 x 30 cm. 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: childhoodTwo,
    title: 'spray paint on paper 39 x 30 cm. 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: childhoodThree,
    title: 'spray paint on paper 39 x 30 cm. 2021 ',
    author: 'Nikoletta Papakonstantinou',
  },
];

const fullMoon = [
  {
    img: six,
    title: 'mixed media 39 x 30 cm. 2022',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: seven,
    title: 'mixed media 39 x 30 cm. 2022',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: eight,
    title: 'mixed media 39 x 30 cm. 2022',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: nine,
    title: 'mixed media 39 x 30 cm. 2022',
    author: 'Nikoletta Papakonstantinou',
  },
];

const treeAndRoots = [
  {
    img: plexi1,
    title:
      'Print on paper and plastic membrane attached on plexiglass 14 x 21cm, 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: plexi2,
    title:
      'Print on paper and plastic membrane attached on plexiglass 14 x 21cm, 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: plexi3,
    title:
      'Print on paper and plastic membrane attached on plexiglass 14 x 21cm, 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: plexi4,
    title:
      'Print on paper and plastic membrane attached on plexiglass 14 x 21cm, 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: plexi5,
    title:
      'Print on paper and plastic membrane attached on plexiglass 14 x 21cm, 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: plexi6,
    title:
      'Print on paper and plastic membrane attached on plexiglass 14 x 21cm, 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: plexi7,
    title:
      'Print on paper and plastic membrane attached on plexiglass 14 x 21cm, 2021',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: plexi8,
    title:
      'Print on paper and plastic membrane attached on plexiglass 14 x 21cm, 2021',
    author: 'Nikoletta Papakonstantinou',
  },
];

const further = [
  {
    img: five,
    title: 'Untitled, Acrylic paint and oil on canvas, 2015',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: four,
    title: 'mixed media 39 x 30 cm. 2022',
    author: 'Nikoletta Papakonstantinou',
  },

  {
    img: pencilAndSpray,
    title: 'Untitled, Spray paint and pencil on paper, 65 x 50cm,  2021  ',
    author: 'Nikoletta Papakonstantinou',
  },
  {
    img: darkMatter,
    title: 'Untitled, Acrylic paint on Canvas,  60x 60 cm, 2018  ',
    author: 'Nikoletta Papakonstantinou',
  },
];

function DrawingMixedMedia() {
  const [childhoodStoryImage, setChildhoodStoryImage] = React.useState(0);
  const [isChildhoodStoryViewerOpen, setIsChildhoodStoryViewerOpen] = React.useState(false);
  const [fullMoonImage, setFullMoonImage] = React.useState(0);
  const [isFullMoonViewerOpen, setIsFullMoonViewerOpen] = React.useState(false);
  const [treeAndRootsImage, setTreeAndRootsImage] = React.useState(0);
  const [isTreeAndRootsViewerOpen, setIsTreeAndRootsViewerOpen] = React.useState(false);
  const [furtherImage, setFurtherImage] = React.useState(0);
  const [isFurtherViewerOpen, setIsFurtherViewerOpen] = React.useState(false);

  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Childhood story</strong>
        </h1>
        <p style={{ color: 'black' }}>
          This short series is inspired by an early childhood story in which the
          moon is visiting “our house” every night in order to drink milk and
          get some rest till the morning comes. This story’s been crucial for
          Nikoletta ’s work as it represents her belief that seeking into our
          early memories can bring up very unique and original ideas. That’s why
          she chose to bring to life such incidents and stories by protecting
          them and carrying them around, as a significant part of her inner
          self.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {childhoodStory.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setChildhoodStoryImage(index);
                setIsChildhoodStoryViewerOpen(true);
              },
              characterType: 'Childhood Story Artwork'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">The full moon series</strong>
        </h1>
        <p style={{ color: 'black' }}>
          Based on the “childhood story” I created some enlighten works of art
          with the metal flag as an addition, which in this case, as a danger
          symbol, illustrates the fear towards adulthood and it’s uncertainty.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {fullMoon.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setFullMoonImage(index);
                setIsFullMoonViewerOpen(true);
              },
              characterType: 'Full Moon Artwork'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">The tree and his roots</strong>
        </h1>
        <p style={{ color: 'black' }}>
          The idea behind this series is the accidental co-occurrence of two
          concepts: reality and its distant memory; the actual incidents we
          experienced long ago and their impression on us through the years; the
          smell, the shape or the color of the flowers, which might be less
          bright and blue than the ones we were able to see when we were young.
        </p>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {treeAndRoots.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setTreeAndRootsImage(index);
                setIsTreeAndRootsViewerOpen(true);
              },
              characterType: 'Tree And Roots Artwork'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      <Container>
        <h1 className="project-heading">
          <strong className="text-accent">Further works</strong>
        </h1>
        <Row style={{ justifyContent: 'center', paddingBottom: '10px' }} />
      </Container>
      <ImageList
        variant="masonry"
        cols={2}
        gap={20}
        sx={{
          '@media (max-width: 600px)': {
            columnCount: 1,
          },
        }}
      >
        {further.map((src, index) => (
          <ImageListItem key={src.img}>
            {createImageViewerButton({
              index,
              src,
              onImageClick: (index) => {
                setFurtherImage(index);
                setIsFurtherViewerOpen(true);
              },
              characterType: 'Further Artwork'
            })}
            {createStyledImageListItemBar(src.title, src.author)}
          </ImageListItem>
        ))}
      </ImageList>
      {/* All Image Viewers at the top level for full-screen display */}
      {createImageViewer({
        isOpen: isChildhoodStoryViewerOpen,
        images: childhoodStory.map(item => item.img),
        currentIndex: childhoodStoryImage,
        onClose: () => setIsChildhoodStoryViewerOpen(false),
      })}
      {createImageViewer({
        isOpen: isFullMoonViewerOpen,
        images: fullMoon.map(item => item.img),
        currentIndex: fullMoonImage,
        onClose: () => setIsFullMoonViewerOpen(false),
      })}
      {createImageViewer({
        isOpen: isTreeAndRootsViewerOpen,
        images: treeAndRoots.map(item => item.img),
        currentIndex: treeAndRootsImage,
        onClose: () => setIsTreeAndRootsViewerOpen(false),
      })}
      {createImageViewer({
        isOpen: isFurtherViewerOpen,
        images: further.map(item => item.img),
        currentIndex: furtherImage,
        onClose: () => setIsFurtherViewerOpen(false),
      })}
    </Container>
  );
}

export default DrawingMixedMedia;
